import { ACTIONS_POSTINGS } from '../actions/postings';

export const postings = (state = {}, action) => {
  switch (action.type) {
    case ACTIONS_POSTINGS.ADD_POSTINGS: {
      return { ...state, ...action.data };
    }
    case ACTIONS_POSTINGS.CHANGE_POSTING: {
      const { newById } = action;
      return { ...state, byIds: { ...state.byIds, [newById.posting_number]: newById } };
    }

    case ACTIONS_POSTINGS.CHANGE_POSTING_MANY: {
      const { newByIds } = action;
      return { ...state, byIds: { ...state.byIds, ...newByIds } };
    }

    default:
      return state;
  }
};
